import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Form } from "@angular/forms";
import { APIS } from "src/app/shared/constants";

@Injectable({
  providedIn: "root",
})
export class TemplateService {
  constructor(private httpClient: HttpClient) {}

  private get nodeHeaders() {
    return new HttpHeaders({ Authorization: 'Bearer PLACEHOLDER_NODE_TOKEN' });
  }

  getTemplate(userId: string, companyId: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl +
        `template/getAllTemplates?userId=${userId}&companyId=${companyId}`,
      { headers: this.nodeHeaders }
    );
  }

  toggleTemplate(templateId: string, userId: string) {
    return this.httpClient.put(
      APIS.nodeBaseUrl +
        `template/toggleByTempId?templateId=${templateId}&userId=${userId}`,
      {},
      { headers: this.nodeHeaders }
    );
  }

  deleteTemplate(templateId: string, userId: string) {
    return this.httpClient.delete(
      APIS.nodeBaseUrl + `template/delete?id=${templateId}&userId=${userId}`,
      { headers: this.nodeHeaders }
    );
  }

  addInstructions(
    userId: string,
    normalDay: string,
    cheatDay: string,
    detoxDay: string,
    createrId: string
  ) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `instructions/add`,
      { userId, normalDay, cheatDay, detoxDay, createrId },
      { headers: this.nodeHeaders }
    );
  }

  getInstructions(userId: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `instructions/getByUserId/${userId}`,
      { headers: this.nodeHeaders }
    );
  }

  getActionLog(userId: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `dietitian/getAllDietitianActions?userId=${userId}`,
      { headers: this.nodeHeaders }
    );
  }

  updateInstructions(
    id: string,
    userId: string,
    normalDay: string,
    cheatDay: string,
    detoxDay: string,
    createrId: string
  ) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `instructions/update/${id}`,
      { userId, normalDay, cheatDay, detoxDay, createrId },
      { headers: this.nodeHeaders }
    );
  }

  getQaByUser(id: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `qa/getByUserId/${id}`,
      { headers: this.nodeHeaders }
    );
  }

  createQa(userId: string, createrId: string, content: any[]) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `qa/add`,
      { userId, createrId, content },
      { headers: this.nodeHeaders }
    );
  }

  updateQaByUser(
    id: string,
    userId: string,
    createrId: string,
    content: any[]
  ) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `qa/update/${id}`,
      { userId, createrId, content },
      { headers: this.nodeHeaders }
    );
  }

  loginByEmail(mail: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `tmsdp/verifyMail/${mail}`,
      { headers: this.nodeHeaders }
    );
  }

  generateOtp(mail: string) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + "tmsdp/generateOtp",
      { email: mail },
      { headers: this.nodeHeaders }
    );
  }

  verifyOtp(email: string, otp: string) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + "tmsdp/verifyOtp",
      { email, otp },
      { headers: this.nodeHeaders }
    );
  }

  createDietitian(body: object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + "dietitian/createDietitian",
      body,
      { headers: this.nodeHeaders }
    );
  }

  getDietitianRecord(query: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `dietitian/getDietitianRecord?${query}`,
      // 'http://localhost:8080/api/' + `dietitian/getDietitianRecord?mail=${mail}`
      { headers: this.nodeHeaders }
    );
  }

  updateDietitianRecord(payload: FormData) {
    console.log("Payload --> ", payload);
    const headers = new HttpHeaders({
      Authorization: 'Bearer PLACEHOLDER_NODE_TOKEN',
    });
    // "Content-Type": "multipart/form-data",
    // multipart/form-data; boundary=----WebKitFormBoundary5TPWrTQeBZ6yyB3e

    return this.httpClient.post(
      APIS.nodeBaseUrl + `dietitian/updateDietitianRecord`,
      // 'http://localhost:8080/api/' + `dietitian/updateDietitianRecord`,
      payload, { headers }
    );
  }

  handleDietitianAction(
    dietitianId: string,
    actionId: string,
    userId: string,
    actionName: string,
    companyId: string
  ) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `dietitian/newDietitianAction`,
      {
        dietitianId,
        actionId,
        userId,
        actionName,
        companyId,
        dietitianName: localStorage.getItem("dietitianName"),
      },
      { headers: this.nodeHeaders }
    );
  }

  getAllDietitianActionSummary(dietitianId: string, page: number, companyID?: string) {
    let url = APIS.nodeBaseUrl + `dietitian/dietitianActions?dietitianId=${dietitianId}&page=${page}`;
    if (companyID) url += `&companyID=${companyID}`;
    return this.httpClient.get(url, { headers: this.nodeHeaders });
  }

  getAllDietitians(companyId: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl +
        `dietitian/getAllDietitianRecord?companyId=${companyId}`,
      { headers: this.nodeHeaders }
    );
  }

  createAssignedDietitian(payload: Object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `dietitian/createAssignedDietitian`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  updateAssignedDietitian(id: string, payload: Object) {
    return this.httpClient.put(
      APIS.nodeBaseUrl + `dietitian/updateAssignedDietitian?id=${id}`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  getProfileLink(body: object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `tmsdp/genLink`,
      body,
      { headers: this.nodeHeaders }
    );
  }

  getLinkNw(body: object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `tmsdp/genLinkNw`,
      body,
      { headers: this.nodeHeaders }
    );
  }

  getSingleCompanyRecord() {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `tmsdp/getCompany?companyId=yellowsquash`,
      { headers: this.nodeHeaders }
    );
  }

  getSingleCompanyRecordtemp(companyId) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `tmsdp/getCompany?companyId=${companyId}`,
      { headers: this.nodeHeaders }
    );
  }

  generatePdf(
    companyId: string,
    date: string,
    authToken: string,
    userId: string,
    dietitianName: string,
    dietitianEmail: string
  ) {
    const headers = new HttpHeaders({
      Accept: "application/pdf",
      Authorization: 'Bearer PLACEHOLDER_NODE_TOKEN',
    });

    return this.httpClient.get(
      APIS.pythonBaseUrl +
        `gen_pdf?auth_token=${authToken}&date_range=7&date=${date}&company_id=${companyId}&user_id=${userId}&trigger_webhook=true&dietitian_name=${dietitianName}&dietitian_email=${dietitianEmail}`,
      {
        headers: headers,
        responseType: "blob",
      }
    );
  }


  generateNewPdf(
    companyId: string,
    userId: string,
    dietitianName: string,
    dietitianEmail: string
  ) {
    const headers = new HttpHeaders({
      Accept: "application/pdf",
      Authorization: 'Bearer PLACEHOLDER_NODE_TOKEN',
    });

    // https://pythonapi.smartdietplanner.com/gen_pdf_singlePage2?date_range=7&company_id=Nutrabox&user_id=nutraboxpdf
    return this.httpClient.get(
      APIS.pythonBaseUrl +
        `gen_pdf_singlePage2?date_range=7&company_id=${companyId}&user_id=${userId}&trigger_webhook=true&dietitian_name=${dietitianName}&dietitian_email=${dietitianEmail}`,
      {
        headers: headers,
        responseType: "blob",
      }
    );
  }

  generateTestPdf(
    companyId: string,
    userId: string,
    dietitianName: string,
    dietitianEmail: string
  ) {
    const headers = new HttpHeaders({
      Accept: "application/pdf",
      Authorization: 'Bearer PLACEHOLDER_NODE_TOKEN',
    });

    // https://pythonapi.smartdietplanner.com/test_gen_pdf?company_id=smartdietplanner&user_id=red0001&dietitian_name=Manisha&dietitian_email=manisha%40smartdietplanner.com
    return this.httpClient.get(
      APIS.pythonBaseUrl + `fast_gen?user_id=${userId}&company_id=${companyId}&design=new`,
      {
        headers: headers,
        responseType: "blob",
      }
    );
  }

  addHealthParams(payload: Object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `profile/addHealthParams`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  getHealthParams(userId: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `profile/getHealthParamsByUserId?userId=${userId}`,
      { headers: this.nodeHeaders }
    );
  }

  updateHealthParams(payload: Object) {
    return this.httpClient.put(
      APIS.nodeBaseUrl + `profile/updateHealthParams`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  verifyDietPlanRepeat(mail: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `dietitian/isDietPlanRepeated?email=${mail}`,
      { headers: this.nodeHeaders }
    );
  }

  setRepeatForFutureDaysFalse(email: string) {
    return this.httpClient.put(
      APIS.nodeBaseUrl + `dietitian/setRepeatForFutureDaysFalse`,
      { email },
      { headers: this.nodeHeaders }
    );
  }

  canAddUser(email: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `dietitian/canAddUser?email=${email}`,
      { headers: this.nodeHeaders }
    );
  }

  newUserAddAction(email: string) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `dietitian/newUserAddAction`,
      { email },
      { headers: this.nodeHeaders }
    );
  }

  searchUser(query: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `tmsdp/searchUser?${query}`,
      { headers: this.nodeHeaders }
    );
  }

  canAddProfile(query: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `dietitian/canAddProfile?${query}`,
      { headers: this.nodeHeaders }
    );
  }

  createIndividualDietitian(formData: FormData) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + "dietitian/createIndividualDietitian",
      formData,
      { headers: this.nodeHeaders }
    );
  }

  updateDietitian(formData: FormData) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `dietitian/updateDietitianRecord`,
      formData,
      { headers: this.nodeHeaders }
    );
  }

  createFoodDietRecord(body: Object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `foodDietPlan/createRecord`,
      body,
      { headers: this.nodeHeaders }
    );
  }

  updateFoodDietRecord(body: Object, id: String) {
    return this.httpClient.put(
      APIS.nodeBaseUrl + `foodDietPlan/updateFoodDietPlanRecord?id=${id}`,
      body,
      { headers: this.nodeHeaders }
    );
  }

  getFoodDietPlanRecords(query: String) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + "foodDietPlan/getFoodDietPlanRecord" + query,
      { headers: this.nodeHeaders }
    );
  }

  delOtherFoodDietPlanRecords(customerId: String) {
    return this.httpClient.delete(
      APIS.nodeBaseUrl + "foodDietPlan/delOtherDietPlanPresentFuture", {
      headers: this.nodeHeaders,
      body: {
        customerId: customerId
      }
    }
    );
  }

  getFoodRecipeRecords(query: String) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + "ingredient/getFoodRecipe" + query,
      { headers: this.nodeHeaders }
    );
  }

  getFoodIngredientsRecords(query: String) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + 'ingredient/getIngredients' + query,
      { headers: this.nodeHeaders }
    );
  }

  getIngredientsRecipeRecords(query: String) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + 'ingredient/getIngredientsRecipe' + query,
      { headers: this.nodeHeaders }
    );
  }

  getRecordFromOrigin(id: String) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + "foodDietPlan/getRecordFromOrigin?id=" + id,
      { headers: this.nodeHeaders }
    );
  }

  getAuthenticate(payload: Object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + "tmsdp/auth",
      payload,
      { headers: this.nodeHeaders }
    );
  }

  saveDietPlanRecordToOrigin(body: Object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + "foodDietPlan/saveRecordToOrigin",
      body,
      { headers: this.nodeHeaders }
    );
  }

  updateDietPlanRecordToOrigin(id: string, body: Object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + "foodDietPlan/updateRecordAtOrigin?id=" + id,
      body,
      { headers: this.nodeHeaders }
    );
  }

  dietForDeficiency(id: string, key: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `tmsdp/dietForDeficiency?userId=${id}&companyKey=${key}`,
      { headers: this.nodeHeaders }
    );
  }

  initiatePayment(email: string) {
    return this.httpClient.post(
      "http://localhost:8080/api/" + `payment/createOrder`,
      {
        amount: 100,
        amount_due: 100,
        amount_paid: 0,
        attempts: 0,
        created_at: 1725646556,
        currency: "INR",
        entity: "order",
        id: "order_OtyaZ0qlXStZ7o",
        notes: [],
        offer_id: null,
        receipt: "recipt#1",
        status: "created",
      },
      { headers: this.nodeHeaders }
    );
  }

  assignedDietitian(email: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `dietitian/assignedDietitianRecord?userId=${email}`,
      { headers: this.nodeHeaders }
    );
  }

  getExternalFoodItem(query: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `nwExt/get?${query}`,
      { headers: this.nodeHeaders }
    );
  }

  newExternalFoodItem(body: object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `nwExt/nw`,
      body,
      { headers: this.nodeHeaders }
    );
  }

  updateExternalFoodItem(id, body) {
    return this.httpClient.put(
      APIS.nodeBaseUrl + `nwExt/update/${id}`,
      body,
      { headers: this.nodeHeaders }
    );
  }

  getChatbotRecords(userId: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `chatbot/record?userId=${userId}`,
      { headers: this.nodeHeaders }
    );
  }

  getAiApiToken(query: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `profile/getToken?${query}`,
      { headers: this.nodeHeaders }
    );
  }

  updateCreateProfile(body: Object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `tmsdp/aiFitrofyGenLink`,
      body,
      // { headers: this.nodeHeaders }
    );
  }

  // ---------------- Exercise Library ----------------

  getExercises(companyId: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `exercise/getAll?companyId=${companyId}`,
      { headers: this.nodeHeaders }
    );
  }

  createExercise(formData: FormData) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `exercise/add`,
      formData,
      { headers: this.nodeHeaders }
    );
  }

  // ---------------- Exercise Routines ----------------

  getAllExerciseRoutines(userId: string, companyId: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl +
        `exerciseRoutine/getAllRoutines?userId=${userId}&companyId=${companyId}`,
      { headers: this.nodeHeaders }
    );
  }

  getExerciseRoutineById(id: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `exerciseRoutine/getRoutine?id=${id}`,
      { headers: this.nodeHeaders }
    );
  }

  createExerciseRoutine(payload: Object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `exerciseRoutine/add`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  updateExerciseRoutine(id: string, userId: string, payload: Object) {
    return this.httpClient.put(
      APIS.nodeBaseUrl +
        `exerciseRoutine/update?id=${id}&userId=${userId}`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  deleteExerciseRoutine(id: string, userId: string) {
    return this.httpClient.delete(
      APIS.nodeBaseUrl + `exerciseRoutine/delete?id=${id}&userId=${userId}`,
      { headers: this.nodeHeaders }
    );
  }

  toggleExerciseRoutineEnabled(id: string, userId: string) {
    return this.httpClient.put(
      APIS.nodeBaseUrl +
        `exerciseRoutine/toggleEnabled?id=${id}&userId=${userId}`,
      {},
      { headers: this.nodeHeaders }
    );
  }

  assignExerciseRoutine(payload: Object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `exerciseRoutine/assign`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  getAssignedExerciseRoutines(userId: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `exerciseRoutine/getAssignedForUser?userId=${userId}`,
      { headers: this.nodeHeaders }
    );
  }

  unassignExerciseRoutine(assignmentId: string) {
    return this.httpClient.put(
      APIS.nodeBaseUrl + `exerciseRoutine/unassign?id=${assignmentId}`,
      {},
      { headers: this.nodeHeaders }
    );
  }

  // ─── Exercise tracker (see Exercise_Tracker_API_Frontend_Guide) ───

  private trackQuery(params: { [key: string]: any }) {
    return Object.keys(params)
      .filter((k) => params[k] !== undefined && params[k] !== null && params[k] !== "")
      .map((k) => `${k}=${encodeURIComponent(params[k])}`)
      .join("&");
  }

  startExerciseSession(payload: Object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `exerciseRoutine/track/start`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  updateExerciseEntry(payload: Object) {
    return this.httpClient.put(
      APIS.nodeBaseUrl + `exerciseRoutine/track/exercise`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  saveExerciseSession(payload: Object) {
    return this.httpClient.post(
      APIS.nodeBaseUrl + `exerciseRoutine/track/save`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  completeExerciseSession(payload: Object) {
    return this.httpClient.put(
      APIS.nodeBaseUrl + `exerciseRoutine/track/complete`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  skipExerciseSession(payload: Object) {
    return this.httpClient.put(
      APIS.nodeBaseUrl + `exerciseRoutine/track/skip`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  resetExerciseSession(payload: Object) {
    return this.httpClient.put(
      APIS.nodeBaseUrl + `exerciseRoutine/track/reset`,
      payload,
      { headers: this.nodeHeaders }
    );
  }

  getExerciseTrackDay(userId: string, date?: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `exerciseRoutine/track/day?` + this.trackQuery({ userId, date }),
      { headers: this.nodeHeaders }
    );
  }

  getExerciseTrackHistory(params: {
    userId: string;
    from?: string;
    to?: string;
    status?: string;
    routineId?: string;
    page?: number;
    limit?: number;
  }) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `exerciseRoutine/track/history?` + this.trackQuery(params),
      { headers: this.nodeHeaders }
    );
  }

  getExerciseTrackDashboard(userId: string, from?: string, to?: string) {
    return this.httpClient.get(
      APIS.nodeBaseUrl + `exerciseRoutine/track/dashboard?` + this.trackQuery({ userId, from, to }),
      { headers: this.nodeHeaders }
    );
  }
}
